import { appPaths, HOME_PATH } from "../../../shared/routing/appPaths";
import type { ConnectorSetupView } from "./useConnectorSetup";

/**
 * Where a sign-in goes (onboarding.md OB-5, OB-Q7 (a)): the guide opens once, at the first
 * sign-in of a person who has not met it and whose PC is not set up yet. A return path the person
 * came with wins, since a pairing link is setup itself; later sign-ins go where they always went.
 */
export function signInDestination(returnPath: string, setup: Pick<ConnectorSetupView, "guide" | "progress"> | null): string {
  if (returnPath !== HOME_PATH || setup === null) return returnPath;
  return setup.guide.state === "not_introduced" && !setup.progress.complete ? appPaths.connectorSetup() : returnPath;
}

/** Whether the destination can depend on the guide at all, so its state is worth reading first. */
export function signInMayOpenGuide(returnPath: string): boolean {
  return returnPath === HOME_PATH;
}
